import React from "react";
import { NavLink } from "react-router-dom";
import Header from "../../components/Header";
import withAuth from "../../services/withAuth";
import NotFound from "../NotFound";
import AuthService from "../../services/AuthService";
import MembersApi from "../../services/portal-api/MembersApi"
import LoadingSpinner from "../../components/LoadingSpinner";
import SelectInput from "../../components/Form/components/SelectInput";
import RestartQueue from "../AdminTools/components/components/RestartQueue";
import RolesAndPermissionsTable from "./table";
import swal from "sweetalert";
import NavigationBar from "../Navigation";

class RolesAndPermissions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            permissionLists: [],
            isLoading: false,
            checked: true
        }
    }

    componentDidMount() {
        document.title = 'Roles and Permissions - duskPortal';
        document.body.className = 'page--green';

        this.setState({
            isLoading: true
        })

        MembersApi.getRolesAndPermissions(this.handleRolesAndPermissions);
    }

    handleRolesAndPermissions = (result) => {
        if (result.status === 401) {
            this.props.sessionExpired();
            return;
        }
        this.setState({
            permissionLists: result.json,
            isLoading: false
        });
    }

    can = (value) => {
        return AuthService.getPermissions().includes(value);
    }

    handleChange = () => {
        this.setState(prevState => ({
            checked: !prevState.checked
        }));
    }

    givePermission = (isChecked, value, role) => {
        MembersApi.assignPermissionToRole(role, value, (response) => {
            if (response.json.success == false) {
                swal("Something went wrong", {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                });
                return false;
            } else {
                if (response.json.success == true) {
                    MembersApi.getRolesAndPermissions(this.handleRolesAndPermissions);
                }
            }
        });
    }



    render() {
        return (
            this.can('roles and permission') ?
                <div>
                    <Header />
                    <main className="content padding--80--bot" role="main">
                        <div className="container container--wide padding--40">
                            {AuthService.getAdminType() == 1 &&
                                <div className="info-wrap col gutter--40 margin--10--bot" style={{ borderBottom: "1px solid #ccc", display: "flex", flexWrap: "wrap" }}>
                                    <div className="col">
                                        <NavigationBar />
                                    </div>
                                </div>
                            }

                            <div className="padding--15" style={{ display: 'flex', alignItems: 'center' }}>
                                <h2 className="text--40 text--light text--color" style={{ flex: '1' }}>
                                    Roles and Permissions
                                </h2>
                                {this.state.checked ?
                                    <a onClick={this.handleChange} style={{ cursor: 'pointer' }}>
                                        <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth="0"
                                            version="1"
                                            viewBox="0 0 48 48"
                                            enableBackground="new 0 0 48 48"
                                            height="1.5em"
                                            width="1.5em"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path fill="#424242" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"></path>
                                            <path fill="#FB8C00" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"></path>
                                            <circle fill="#C76E00" cx="24" cy="31" r="3"></circle>
                                        </svg>
                                    </a>
                                    :
                                    <a onClick={this.handleChange} style={{ cursor: 'pointer' }}>
                                        <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth="0"
                                            version="1"
                                            viewBox="0 0 48 48"
                                            enableBackground="new 0 0 48 48"
                                            height="1.5em"
                                            width="1.5em"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path fill="#424242" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6h4C34,8.5,29.5,4,24,4z"></path>
                                            <path fill="#FB8C00" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"></path>
                                            <circle fill="#C76E00" cx="24" cy="31" r="3"></circle>
                                        </svg>
                                    </a>
                                }
                            </div>

                            <LoadingSpinner isVisible={this.state.isLoading} />
                            <RolesAndPermissionsTable
                                permissionLists={this.state.permissionLists}
                                givePermission={this.givePermission}
                                paddleLock={this.state.checked}
                            />
                        </div>
                    </main>
                </div>
                :
                <NotFound forbidden={true} />
        );
    }
}

export default withAuth(RolesAndPermissions);